// extracted by mini-css-extract-plugin
export default {"list":"custom_field-module___list___f278cc4d","item":"custom_field-module___item___bd66c4c4"};